import kformUtils from '~/components/kform/utils/kform-utils';

export default /* @ngInject */ (
	/** @type {any} */ $scope,
	/** @type {import('angular').ITimeoutService} */ $timeout,
	/** @type {any} */ MethodService,
) => {
	if ($scope.component.options) {
		$scope.component.options.createKid = $scope.component.kdata?.kid ?? $scope.component.kdata?.mf_order;
		$scope.component.options.dico = $scope.component.kdata?.mf_dico || false;
	}
	$scope.mfSelect = (
		/** @type {Function} */ callback,
		/** @type {any} */ item,
		/** @type {Event} */ event,
	) => {
		if (typeof callback === 'function') {
			callback(event, item);
		}
		else if (callback in MethodService.methods) {
			$timeout(() => {
				$timeout(() => {
					MethodService.methods[callback](item);
				});
			});
		}
		else if (typeof callback === 'string') {
			const custom = ''.concat(callback, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
				item,
			});
		}
	};
};